// Generated by scripts/build-ui-icons.mjs.
export { Brain as default } from "../ui/glyphs-1";
